/* AMC fit-select (loaded from snippets/amc-page-transition.liquid on product, collection, search and home pages).
   Product option menus whose text is longer than the field (vehicle + product code, long model names)
   get a full-width button that wraps the text and opens a readable picker with a filter.
   The original <select> stays in the form as the source of truth, so cart and variant logic are unchanged. */
(() => {
  if (window.__amcFitSelect) return;
  window.__amcFitSelect = true;
  const esc = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const FIT_SCOPE = '.amc-deck-choice select, variant-selects select, .product-form__input select, .amc-card-option-modal select, form[action*="/cart/add"] select';
  const fitCss = `
.amc-fs{position:relative;display:block;width:100%;min-width:0}
.amc-fs>select{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;min-width:0!important;margin:0!important;opacity:0!important;pointer-events:none!important}
.amc-fs__btn{position:relative;display:flex;flex-direction:column;justify-content:center;gap:3px;box-sizing:border-box;width:100%;min-height:54px;margin:0;padding:10px 46px 10px 14px;border:1.5px solid #9FB0BF;border-radius:12px;background:#fff;color:#061A35;font-family:inherit;font-size:15px;font-weight:700;letter-spacing:0;line-height:1.3;text-align:left;text-transform:none;white-space:normal;overflow-wrap:anywhere;cursor:pointer;-webkit-tap-highlight-color:transparent}
.amc-fs__btn:hover{border-color:#061A35}
.amc-fs__btn:focus-visible{outline:2px solid #1A5CFF;outline-offset:2px}
.amc-fs__btn.is-empty .amc-fs__main{color:#5E7080;font-weight:600}
.amc-fs__btn[disabled]{opacity:.55;cursor:not-allowed}
.amc-fs__main{display:block}
.amc-fs__sub{display:block;color:#5E7080;font-size:12px;font-weight:700;letter-spacing:.02em}
.amc-fs__btn svg{position:absolute;top:50%;right:14px;width:18px;height:18px;margin-top:-9px;fill:none;stroke:#061A35;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}
.amc-fsp{position:fixed;z-index:2147482500;inset:0;display:flex;align-items:flex-end;justify-content:center;background:rgba(6,26,53,.46)}
.amc-fsp:modal{box-sizing:border-box;width:100%;height:100%;max-width:none;max-height:none;margin:0;padding:0;border:0}
.amc-fsp::backdrop{background:transparent}
.amc-fsp__sheet{position:relative;display:flex;flex-direction:column;box-sizing:border-box;width:100%;max-width:560px;max-height:92vh;max-height:calc(100dvh - 16px);border-radius:22px 22px 0 0;background:#fff;color:#061A35;font-family:inherit;box-shadow:0 -18px 40px -16px rgba(6,26,53,.5);overflow:hidden}
.amc-fsp__head{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:16px 14px 10px 20px}
.amc-fsp__title{margin:0;font-size:17px;font-weight:800;letter-spacing:-.01em;line-height:1.2}
.amc-fsp__title small{display:block;margin-top:3px;color:#5E7080;font-size:12px;font-weight:700;letter-spacing:0}
.amc-fsp__sheet::after{content:"";position:absolute;left:0;right:8px;bottom:0;height:40px;background:linear-gradient(180deg,rgba(255,255,255,0),#fff);pointer-events:none;transition:opacity .15s ease}
.amc-fsp__sheet.is-end::after{opacity:0}
.amc-fsp__close{display:grid;flex:0 0 44px;width:44px;height:44px;place-items:center;margin:0;padding:0;border:0;border-radius:50%;background:#F5F5F7;color:#061A35;cursor:pointer}
.amc-fsp__close svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:2.2;stroke-linecap:round}
.amc-fsp__find{box-sizing:border-box;width:calc(100% - 32px);min-height:46px;margin:0 16px 8px;padding:0 16px;border:1.5px solid #D5DBE2;border-radius:999px;background:#fff;color:#061A35;font:600 16px/1.2 inherit;font-family:inherit}
.amc-fsp__find:focus{outline:2px solid #1A5CFF;outline-offset:1px}
.amc-fsp__list{flex:1 1 auto;min-height:0;margin:0;padding:2px 10px calc(26px + env(safe-area-inset-bottom,0px));overflow-x:hidden;overflow-y:scroll;scrollbar-width:thin;scrollbar-color:#9FB0BF transparent;overscroll-behavior:contain;list-style:none;-webkit-overflow-scrolling:touch}
.amc-fsp__list::-webkit-scrollbar{width:6px}
.amc-fsp__list::-webkit-scrollbar-thumb{border-radius:6px;background:#9FB0BF}
.amc-fsp__list li+li{border-top:1px solid #EEF0F3}
.amc-fsp__opt{display:grid;grid-template-columns:minmax(0,1fr) 22px;align-items:center;gap:10px;box-sizing:border-box;width:100%;min-height:46px;margin:0;padding:8px 12px;border:0;border-radius:10px;background:none;color:#061A35;font-family:inherit;font-size:14.5px;font-weight:700;line-height:1.25;text-align:left;white-space:normal;overflow-wrap:anywhere;cursor:pointer}
.amc-fsp__opt small{display:block;margin-top:1px;color:#5E7080;font-size:11.5px;font-weight:700;letter-spacing:.02em}
.amc-fsp__opt:hover,.amc-fsp__opt.is-active{background:#F5F5F7}
.amc-fsp__opt[aria-selected="true"]{background:#F5F5F7}
.amc-fsp__opt[aria-selected="true"]::after{content:"";width:20px;height:20px;border-radius:50%;background:#D71920 url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none' stroke='%23fff' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m5.5 10.5 3 3 6-7'/%3E%3C/svg%3E") center/20px no-repeat}
.amc-fsp__opt[aria-disabled="true"]{opacity:.42;cursor:not-allowed}
.amc-fsp__none{margin:0;padding:18px 14px;color:#5E7080;font-size:14px;font-weight:600}
@media(min-width:750px){.amc-fsp{align-items:center;padding:24px}.amc-fsp__sheet{max-height:min(780px,90vh);border-radius:22px}}
`;
  const flyCss = `
.amc-home-option-field select,.amc-deck-choice select{max-width:100%}
body:not(.collection-template):not(.index-template) .amc-card-option-modal .popup-modal__content{box-sizing:border-box;width:min(430px,100vw);max-width:430px;background:#fff}
body:not(.collection-template):not(.index-template) .amc-card-option-modal__body{padding:18px}
body:not(.collection-template):not(.index-template) .amc-quick-add-guidance{display:flex;flex-direction:column;gap:3px;padding:16px 56px 14px 18px;border-bottom:1px solid #E6E8EC;background:#F5F5F7;color:#061A35}
body:not(.collection-template):not(.index-template) .amc-quick-add-guidance strong{font-size:16px;font-weight:800;line-height:1.2}
body:not(.collection-template):not(.index-template) .amc-quick-add-guidance span{font-size:12px;font-weight:600;line-height:1.4}
body:not(.collection-template):not(.index-template) .amc-home-option-fields{display:grid;gap:14px}
body:not(.collection-template):not(.index-template) .amc-home-option-field label{display:block;margin:0 0 6px;color:#061A35;font-size:13px;font-weight:800;line-height:1.3}
body:not(.collection-template):not(.index-template) .amc-home-option-field select{display:block;box-sizing:border-box;width:100%;min-height:50px;padding:10px 36px 10px 12px;border:1.5px solid #9FB0BF;border-radius:12px;background:#fff;color:#061A35;font-size:15px;font-weight:700;line-height:1.3}
body:not(.collection-template):not(.index-template) .amc-home-option-fixed{margin:0;padding:12px 14px;border:1px solid #E6E8EC;border-radius:12px;background:#F5F5F7;color:#061A35;font-size:14px;font-weight:700;line-height:1.3}
body:not(.collection-template):not(.index-template) .amc-home-option-price{margin:14px 0 0;color:#061A35;font-size:16px;font-weight:800;line-height:1.3}
body:not(.collection-template):not(.index-template) .amc-home-option-status{margin:10px 0;color:#5E7080;font-size:12px;font-weight:700;line-height:1.35}
body:not(.collection-template):not(.index-template) .amc-home-option-status.is-ready{color:#17713d}
body:not(.collection-template):not(.index-template) .amc-card-option-modal__submit{width:100%;min-height:50px;border:0;border-radius:999px;background:#D71920;color:#fff;font-size:15px;font-weight:800;line-height:1;cursor:pointer}
body:not(.collection-template):not(.index-template) .amc-card-option-modal__submit:disabled{opacity:.5;cursor:not-allowed}
`;
  const flyStyle = document.createElement('style');
  flyStyle.id = 'amc-option-flyout-style';
  flyStyle.textContent = flyCss;
  document.head.append(flyStyle);
  const CHEVRON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>';
  const CROSS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  const ruler = document.createElement('canvas').getContext('2d');
  const splitLabel = (text) => {
    const parts = String(text).split(/\s[—–]\s/);
    return parts.length > 1 ? [parts.slice(0, -1).join(' — '), parts[parts.length - 1]] : [String(text), ''];
  };
  const labelFor = (select) => {
    const field = select.closest('.amc-deck-choice__field, .product-form__input, .amc-home-option-field, div');
    const label = (select.id && document.querySelector('label[for="' + CSS.escape(select.id) + '"]')) || (field && field.querySelector('label, legend'));
    return label ? label.textContent.replace(/\s+/g, ' ').trim() : (select.getAttribute('aria-label') || 'Choose an option');
  };
  const needsFit = (select) => {
    if (select.multiple || select.size > 1) return false;
    const width = select.clientWidth;
    if (width < 90) return false;
    /* Vehicle, product-code and configuration menus always use the readable picker: the phone's built-in
       menu shortens long option text and shows only a few rows at a time. */
    if (select.closest('.amc-card-option-modal, .amc-deck-choice')) {
      const texts = [...select.options].map((option) => option.textContent.trim());
      if (texts.length > 6 || texts.some((text) => text.length > 26)) return true;
    }
    const holder = select.parentElement;
    if (holder && select.offsetWidth > holder.clientWidth + 1) return true;
    const style = getComputedStyle(select);
    ruler.font = style.fontWeight + ' ' + style.fontSize + ' ' + style.fontFamily;
    const room = width - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    return [...select.options].some((option) => ruler.measureText(option.textContent.trim()).width > room - 2);
  };

  let fitStyled = false;
  let activePicker = null;
  const openPicker = (select, button) => {
    if (activePicker) return;
    const title = labelFor(select);
    /* A native modal isolates the background without overwriting any parent's inert
       or aria-hidden state. It also sits above an already-open native dialog. */
    const layer = document.createElement('dialog');
    layer.className = 'amc-fsp';
    layer.setAttribute('aria-label', title);
    layer.setAttribute('aria-modal', 'true');
    const real = [...select.options].filter((option) => option.value !== '' && !option.hidden);
    layer.innerHTML = '<div class="amc-fsp__sheet"><div class="amc-fsp__head"><p class="amc-fsp__title">' + esc(title) + '<small>' + real.length + ' options' + (real.length > 6 ? ' · scroll for all' : '') + '</small></p><button type="button" class="amc-fsp__close" aria-label="Close">' + CROSS + '</button></div>' + (real.length > 8 ? '<input class="amc-fsp__find" type="search" placeholder="Type to filter" aria-label="Filter options" autocomplete="off">' : '') + '<ul class="amc-fsp__list" role="listbox" aria-label="' + esc(title) + '"></ul></div>';
    const list = layer.querySelector('.amc-fsp__list');
    const find = layer.querySelector('.amc-fsp__find');
    const overflowBefore = document.documentElement.style.overflow;
    let closed = false;
    const draw = (filter) => {
      const term = (filter || '').trim().toLowerCase();
      const rows = real.filter((option) => !term || option.textContent.toLowerCase().indexOf(term) > -1);
      list.innerHTML = rows.length ? rows.map((option) => {
        const parts = splitLabel(option.textContent.trim());
        return '<li role="presentation"><button type="button" class="amc-fsp__opt" role="option" data-value="' + esc(option.value) + '" aria-selected="' + String(option.value === select.value) + '"' + (option.disabled ? ' aria-disabled="true"' : '') + '><span>' + esc(parts[0]) + (parts[1] ? '<small>' + esc(parts[1]) + '</small>' : '') + '</span></button></li>';
      }).join('') : '<li class="amc-fsp__none" role="presentation">No option matches that. Clear the filter to see all.</li>';
    };
    const close = () => {
      if (closed) return;
      closed = true;
      activePicker = null;
      layer.close();
      layer.remove();
      document.documentElement.style.overflow = overflowBefore;
      document.removeEventListener('keydown', onKey, true);
      document.removeEventListener('focusin', onFocus, true);
      button.setAttribute('aria-expanded', 'false');
      if (button.isConnected && !button.disabled && !button.closest('[inert], [hidden]')) button.focus({ preventScroll: true });
    };
    const choose = (value) => {
      if (select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      close();
    };
    const onKey = (event) => {
      if (!layer.contains(event.target)) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        /* Parent quick-add/details dialogs use keyup; consume this same release
           after focus has returned so one Escape never closes both layers. */
        const clearRelease = () => {
          window.removeEventListener('keyup', release, true);
          window.removeEventListener('keydown', nextKey, true);
          window.removeEventListener('blur', clearRelease);
        };
        const release = (up) => {
          if (up.key !== 'Escape') return;
          up.preventDefault();
          up.stopImmediatePropagation();
          clearRelease();
        };
        const nextKey = (down) => {
          if (down.key === 'Escape' && down.repeat) {
            down.preventDefault();
            down.stopImmediatePropagation();
          } else clearRelease();
        };
        window.addEventListener('keyup', release, true);
        window.addEventListener('keydown', nextKey, true);
        window.addEventListener('blur', clearRelease);
        close();
        return;
      }
      if (event.key === 'Tab') {
        event.preventDefault();
        event.stopImmediatePropagation();
        const stops = [...layer.querySelectorAll('button:not([disabled]):not([aria-disabled="true"]), input:not([disabled])')];
        const at = stops.indexOf(document.activeElement);
        stops[(at + (event.shiftKey ? -1 : 1) + stops.length) % stops.length].focus();
        return;
      }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const rows = [...list.querySelectorAll('.amc-fsp__opt:not([aria-disabled="true"])')];
      if (!rows.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const at = rows.indexOf(document.activeElement);
      rows[(at + (event.key === 'ArrowDown' ? 1 : -1) + rows.length) % rows.length].focus();
    };
    /* Keep the parent's trap registered, but do not let it redirect focus while
       this topmost picker owns it. Native modal isolation blocks outside focus. */
    const onFocus = (event) => {
      if (layer.contains(event.target)) event.stopImmediatePropagation();
    };
    layer.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    layer.addEventListener('close', close);
    layer.addEventListener('click', (event) => {
      if (event.target === layer || event.target.closest('.amc-fsp__close')) { close(); return; }
      const row = event.target.closest('.amc-fsp__opt');
      if (row && row.getAttribute('aria-disabled') !== 'true') choose(row.dataset.value);
    });
    const sheet = layer.querySelector('.amc-fsp__sheet');
    const markEnd = () => sheet.classList.toggle('is-end', list.scrollHeight - list.scrollTop - list.clientHeight < 6);
    list.addEventListener('scroll', markEnd, { passive: true });
    if (find) find.addEventListener('input', () => { draw(find.value); markEnd(); });
    document.addEventListener('keydown', onKey, true);
    document.addEventListener('focusin', onFocus, true);
    draw('');
    document.body.append(layer);
    activePicker = layer;
    layer.showModal();
    document.documentElement.style.overflow = 'hidden';
    button.setAttribute('aria-expanded', 'true');
    const current = list.querySelector('[aria-selected="true"]:not([aria-disabled="true"])') || find || list.querySelector('.amc-fsp__opt:not([aria-disabled="true"])') || layer.querySelector('.amc-fsp__close');
    if (current) { if (current.getAttribute('aria-selected') === 'true') current.scrollIntoView({ block: 'center' }); current.focus({ preventScroll: true }); }
    markEnd();
  };

  const fitOne = (select) => {
    /* Leave the functional native control intact on older dialog-less engines. */
    if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    if (select.dataset.amcFit || !select.isConnected || !select.offsetParent || select.classList.contains('is-pilled')) return;
    if (!needsFit(select)) return;
    select.dataset.amcFit = 'true';
    if (!fitStyled) {
      fitStyled = true;
      const style = document.createElement('style');
      style.id = 'amc-fit-select-style';
      style.textContent = fitCss;
      document.head.append(style);
    }
    const wrap = document.createElement('span');
    wrap.className = 'amc-fs';
    select.before(wrap);
    wrap.append(select);
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'amc-fs__btn';
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-expanded', 'false');
    wrap.append(button);
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    const paintButton = () => {
      const option = select.options[select.selectedIndex];
      const text = option ? option.textContent.trim() : '';
      const parts = splitLabel(text);
      const empty = !option || option.value === '';
      button.classList.toggle('is-empty', empty);
      button.disabled = select.disabled;
      button.setAttribute('aria-label', labelFor(select) + ': ' + text);
      button.innerHTML = '<span class="amc-fs__main">' + esc(parts[0]) + '</span>' + (!empty && parts[1] ? '<span class="amc-fs__sub">' + esc(parts[1]) + '</span>' : '') + CHEVRON;
    };
    paintButton();
    select.addEventListener('change', paintButton);
    new MutationObserver(paintButton).observe(select, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
    button.addEventListener('click', () => { if (!select.disabled) openPicker(select, button); });
  };
  let fitTimer = 0;
  const fitAll = () => { clearTimeout(fitTimer); fitTimer = setTimeout(() => { try { document.querySelectorAll(FIT_SCOPE).forEach(fitOne); } catch (_) {} }, 80); };
  const fitStart = () => {
    fitAll();
    new MutationObserver(records => {
      const relevant = records.some(record => {
        if (record.type === 'attributes') return record.target.matches('modal-dialog,quick-add-modal,product-info') || !!record.target.querySelector?.(FIT_SCOPE);
        return [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.(FIT_SCOPE) || node.querySelector?.(FIT_SCOPE)));
      });
      if (relevant) fitAll();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden'] });
    addEventListener('resize', fitAll, { passive: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitStart, { once: true });
  else fitStart();
})();
